import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {User} from "../../auth/models/User";
import {MatPaginator} from "@angular/material/paginator";
import {Subject, takeUntil} from "rxjs";
import {AdminService} from "../services/admin.service";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {FfkTvDialogComponent} from "./ffk-tv-dialog/ffk-tv-dialog.component";
import Swal from "sweetalert2";
import {EditFfkTvDialogComponent} from "./edit-ffk-tv-dialog/edit-ffk-tv-dialog.component";

@Component({
  selector: 'app-ffk-tv',
  templateUrl: './ffk-tv.component.html',
  styleUrls: ['./ffk-tv.component.scss']
})
export class FfkTvComponent implements OnInit, AfterViewInit, OnDestroy {
  videos = new MatTableDataSource<any>();
  currentUser!: User;
  displayedColumns: string[] = ['url', 'createdAt', 'open', 'remove'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalItems = 0;
  pageSize = 10;
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData() {
    if (this.currentUser) {
      this.adminService.getVideosUrl().subscribe((result: any) => {
        this.videos = new MatTableDataSource(result);
        this.totalItems = result.totalElements;
        this.paginator.length = this.totalItems;
      }, (error: any) => {
        console.error(error);
      });
    }
  }

  openCreateVideoDialog(): void {
    const dialogRef = this.dialog.open(FfkTvDialogComponent, {
      width: '400px',
      height: '250px',
      data: {video: null}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  openEditVideoDialog(video: any): void {
    const dialogRef = this.dialog.open(EditFfkTvDialogComponent, {
      width: '400px',
      height: '250px',
      data: {video}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  deleteVideo(id: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted!',
      'The video has been deleted.',
      'Error',
      'An error occurred while deleting the video.'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!']
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.adminService.deleteVideo(id).subscribe(() => {
            Swal.fire(translations['Deleted!'], translations['The video has been deleted.'], 'success');
            this.loadData();
          }, (error) => {
            Swal.fire(translations['Error'], error.error.message, 'error');
          });
        }
      });
    });
  }
}
